import Submit from '~/components/button/Submit';
import Form from '~/components/Form';
import RadioGroup, { CardOption } from '~/components/form-controls/RadioGroup';
import { useCurrencyFormatter } from '~/utils/formatters';
import {
  editActionTypeFormKey,
  SELECTED_SHIPPING_LINE_TITLE_KEY,
  useLoaderData as useStageLoaderData,
} from './orderEditStage';
import ShippingLine from './ShippingLine';

type LoaderData = ReturnType<typeof useStageLoaderData>;

export function UpdateShippingLineForm({
  data,
}: {
  data: Extract<LoaderData, { editType: 'UPDATE_SHIPPING_LINE' }>;
}) {
  const currencyFormatter = useCurrencyFormatter();

  const deltaMessage = (deltaFromCurrent: string) => {
    const value = Number.parseFloat(deltaFromCurrent);
    if (value === 0) return '';

    return value > 0
      ? `You'll pay an additional ${currencyFormatter(value)}`
      : `You'll receive a refund of ${currencyFormatter(Math.abs(value))}`;
  };

  return (
    <Form name="updateShippingLineForm">
      <input type="hidden" name={editActionTypeFormKey} value={data.editType} />

      <RadioGroup label="Shipping Methods" showLabel={false}>
        <div className="flex flex-col gap-4">
          {data.quotes.map((q, index) => (
            <CardOption
              key={q.title}
              name={SELECTED_SHIPPING_LINE_TITLE_KEY}
              value={q.title}
              defaultChecked={index === 0}
              aria-labelledby={`shipping-line-${q.title}-label`}
              aria-describedby={`shipping-line-${q.title}-delta`}
              required
            >
              <ShippingLine
                title={q.title}
                price={currencyFormatter(Number.parseFloat(q.price.amount))}
              >
                {deltaMessage(q.deltaFromCurrent)}
              </ShippingLine>
            </CardOption>
          ))}
        </div>
      </RadioGroup>

      <Submit>Continue</Submit>
    </Form>
  );
}
